<template>
    <div class="index">
        <el-divider content-position="left">推广统计</el-divider>
        <el-card shadow="always">
            <div slot="header">
                <span>统计数据</span>
            </div>
            <el-tabs v-model="miniProTab" @tab-click="handleClick" type="border-card">
                <el-tab-pane label="注册吧微信小程序" name="reg_now_wc"></el-tab-pane>
                <el-tab-pane label="云上公司注册微信小程序" name="ccrmp_wc"></el-tab-pane>
                <el-tab-pane label="企业火小程序" name="qyh"></el-tab-pane>
                <el-tab-pane label="云上公司注册支付宝小程序" name="ccrmp_ali"></el-tab-pane>
                <el-tab-pane label="企业火公司注册支付宝小程序" name="ccrmp_qyh"></el-tab-pane>
                <!-- <el-tab-pane label="云上公司注册抖音小程序" name="ccrmp_bd"></el-tab-pane> -->
                <el-tabs v-model="fromTab" @tab-click="handleClickfromTab">
                    <el-tab-pane label="腾讯广告" name="4"></el-tab-pane>
                    <el-tab-pane label="公众号" name="3"></el-tab-pane>
                    <el-tab-pane label="春节对联" name="5"></el-tab-pane>
                    <el-tab-pane label="电梯广告" name="1"></el-tab-pane>
                </el-tabs>
                <div
                    style="display: flex;justify-content:space-evenly;font-size: medium;margin-top: 0.2rem;font-weight: bold;">
                    <div>
                        <span class="title">今日新增注册用户数</span>:
                        <span>
                            <el-link @click="openUserDrawer('今日新增注册用户', 'today')" class="font-s-m">{{ todayData.reger }}
                            </el-link>
                        </span>
                    </div>
                    <div>
                        <span class="title">今日下单(未支付)数量</span>:
                        <span><el-link @click="openOrderDrawer('今日下单(未支付)', 'today')" class="font-s-m">{{
                            todayData.order_unPay }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">今日支付成功数量</span>:
                        <span><el-link @click="openOrderDrawer('今日支付成功', 'today_s')" class="font-s-m">{{ todayData.order }}
                            </el-link></span>
                    </div>
                </div>
                <div
                    style="display: flex;justify-content:space-evenly;font-size: medium;margin-top: 0.2rem;font-weight: bold;">
                    <div>
                        <span class="title">昨日新增注册用户数</span>:
                        <span><el-link @click="openUserDrawer('昨日新增注册用户', 'yesterday')" class="font-s-m">{{
                            yesterdayData.reger }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">昨日下单(未支付)数量</span>:
                        <span><el-link @click="openOrderDrawer('昨日下单(未支付)', 'yesterday')" class="font-s-m">{{
                            yesterdayData.order_unPay }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">昨日支付成功数量</span>:
                        <span><el-link @click="openOrderDrawer('昨日支付成功', 'yesterday_s')" class="font-s-m">{{
                            yesterdayData.order }}
                            </el-link></span>
                    </div>
                </div>
                <div
                    style="display: flex;justify-content:space-evenly;font-size: medium;margin-top: 0.2rem;font-weight: bold;">
                    <div>
                        <span class="title_total">新增注册用户总数</span>:
                        <span>
                            <el-link @click="openUserDrawer('新增注册用户总数', 'total')" class="font-s-m">{{ totalData.reger }}
                            </el-link>
                        </span>
                    </div>
                    <div>
                        <span class="title_total">下单(未支付)总数量</span>:
                        <span><el-link @click="openOrderDrawer('下单(未支付)总数量', 'total')" class="font-s-m">{{
                            totalData.order_unPay }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title_total">支付成功总数量</span>:
                        <span><el-link @click="openOrderDrawer('支付成功总数量', 'total_s')" class="font-s-m">{{
                            totalData.order
                        }}
                            </el-link></span>
                    </div>
                </div>
                <hr style="margin-bottom: 0.2rem;margin-top: 0.2rem;">
                <div style="text-align: center;">
                    <el-date-picker size="medium" v-model="date" type="datetimerange" align="right" unlink-panels
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']" @change="handleSearch">
                    </el-date-picker>
                </div>
                <div
                    style="display: flex;justify-content:space-evenly;font-size: medium;margin-top: 0.5rem;font-weight: bold;">
                    <div>
                        <span class="title">新增注册用户数</span>:
                        <span><el-link @click="openUserDrawer('新增注册用户', 'location')" class="font-s-m">{{ locationData.reger
                        }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">下单(未支付)数量</span>:
                        <span><el-link @click="openOrderDrawer('下单(未支付)', 'location')" class="font-s-m">{{
                            locationData.order_unPay }}
                            </el-link></span>
                    </div>
                    <div>
                        <span class="title">支付成功数量</span>:
                        <span><el-link @click="openOrderDrawer('支付成功', 'location_s')" class="font-s-m">{{ locationData.order
                        }}
                            </el-link></span>
                    </div>
                </div>
                <hr style="margin-bottom: 0.2rem;margin-top: 0.2rem;">
                <el-card shadow="always">
                    <div slot="header">
                        <span style="color: #67C23A;">字段统计</span>
                    </div>

                    <el-tabs v-model="fieldTabDate" @tab-click="handleClickFieldDateTab" type="border-card">
                        <el-tab-pane label="今日" name="1"></el-tab-pane>
                        <el-tab-pane label="昨日" name="2"></el-tab-pane>

                        <el-tabs v-model="fieldTypeTab" @tab-click="handleClickFieldTypeTab">
                            <el-tab-pane label="注册推广统计" name="1"></el-tab-pane>
                            <el-tab-pane label="下单推广统计" name="2"></el-tab-pane>
                        </el-tabs>

                        <div>
                            <div style="text-align: center;margin-bottom: 0.2rem;font-size: medium;">
                                {{ date }}{{needFieldType === '1' ||  needFieldType === null ? '注册': '下单'}}推广统计
                            </div>
                            <table id="field-table" border v-for="(v,k,i) in fieldDataNew" :key="k" style="margin-bottom: 0.2rem;">
                                <tr>
                                    <td>来源</td>
                                    <td>{{ k }}</td>
                                    <td colspan="5">{{ v.total }}</td>
                                </tr>
                                <tr>
                                    <td rowspan="2"></td>
                                    <td colspan="1" class="centered">活动</td>
                                    <td colspan="1" class="centered">媒介</td>
                                    <td colspan="1" class="centered">关键词</td>
                                </tr>
                                <tr>
                                    <td >
                                        <!-- <div v-for="(val,key,index) in v.utm_camp" :key="key" style="display: flex;flex-direction: row">
                                            <div style="padding: 0.2rem 0.3rem;border: 0.5px solid #ccc;">{{ key }}</div>
                                            <div style="flex: 1;text-align: right;padding: 0.2rem 0.3rem;border: 0.5px solid #ccc;">{{ val }}</div>
                                        </div> -->
                                        <tr v-for="(val,key,index) in v.utm_camp" :key="key">
                                            <td style="width: 100%;border:none">{{ key }}</td>
                                            <td class="centered-count" style="width: 100%;border: none;">{{ val }}</td>
                                        </tr>
                                    </td>
                                    <td >
                                        <!-- <div v-for="(val,key,index) in v.utm_camp" :key="key" style="display: flex;flex-direction: row">
                                            <div style="padding: 0.2rem 0.3rem;border: 0.5px solid #ccc;">{{ key }}</div>
                                            <div style="flex: 1;text-align: right;padding: 0.2rem 0.3rem;border: 0.5px solid #ccc;">{{ val }}</div>
                                        </div> -->
                                        <tr v-for="(val,key,index) in v.utm_medium" :key="key">
                                            <td style="width: 100%;border: none;">{{ key }}</td>
                                            <td class="centered-count" style="width: 100%;border: none;">{{ val }}</td>
                                        </tr>
                                    </td>
                                    <td >
                                        <!-- <div v-for="(val,key,index) in v.utm_camp" :key="key" style="display: flex;flex-direction: row">
                                            <div style="padding: 0.2rem 0.3rem;border: 0.5px solid #ccc;">{{ key }}</div>
                                            <div style="flex: 1;text-align: right;padding: 0.2rem 0.3rem;border: 0.5px solid #ccc;">{{ val }}</div>
                                        </div> -->
                                        <tr v-for="(val,key,index) in v.utm_term" :key="key">
                                            <td style="width: 100%;border: none;">{{ key }}</td>
                                            <td class="centered-count" style="width: 100%;border: none;">{{ val }}</td>
                                        </tr>
                                    </td>
                                    <!-- <td>{{ key }}</td> -->
                                    <!-- <td class="centered-count">{{ }}</td> -->
                                    <!-- <td>utm_medium_1</td>
                                    <td class="centered-count">20</td>
                                    <td>utm_term_1</td>
                                    <td class="centered-count">22</td> -->
                                </tr>
                            </table>
                            <div v-if="Array.isArray(fieldDataNew)" style="text-align: center;font-size: medium;">
                                没有数据!
                            </div>
                        </div>

                        <!-- <div style="display: flex;flex-direction: row;align-items: stretch">
                            <div style="text-align: center;width: 49%;border-right: 0.5px solid #ccc;padding: 0.2rem 0;">
                                <div>
                                    <span class="title_field_reg">注册</span>
                                </div>



                                <div style="margin-top: 0.2rem;">
                                    <div style="display: flex;justify-content:space-evenly;margin-top: 0.2rem;"
                                        v-for="(item, key, index) in fieldData.reg" :key="index">
                                        <el-tooltip class="item" effect="dark" :content="key" placement="top">
                                            <div
                                                style="width: 5rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: medium;color: #E6A23C;">
                                                {{ key }}
                                            </div>
                                        </el-tooltip>
                                        <div>
                                            <el-link class="font-s-m">
                                                {{ item }}
                                            </el-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="text-align: center;width: 49%;border-left: 0.5px solid #ccc;padding: 0.2rem 0;">
                                <div>
                                    <span class="title_field_order">下单</span>
                                </div>
                                <div style="margin-top: 0.2rem;">
                                    <div style="display: flex;justify-content:space-evenly;margin-top: 0.2rem;"
                                        v-for="(item, key, index) in fieldData.order" :key="index">
                                        <el-tooltip class="item" effect="dark" :content="key" placement="top">
                                            <div
                                                style="width: 5rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: medium;color: #F56C6C;">
                                                {{ key }}
                                            </div>
                                        </el-tooltip>
                                        <div>
                                            <el-link class="font-s-m">
                                                {{ item }}
                                            </el-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </el-tabs>
                </el-card>
            </el-tabs>
        </el-card>
        <el-drawer title="" :visible.sync="userDrawer" direction="rtl" :before-close="handleCloseUserDrawer" size="70%">
            <template slot="title">
                <span style="color: #409eff; font-size: 0.3rem">{{ user_title }}</span>
            </template>
            <user-com :dataType="dataType" />
        </el-drawer>
        <el-drawer title="" :visible.sync="orderDrawer" direction="rtl" :before-close="handleCloseOrderDrawer" size="70%">
            <template slot="title">
                <span style="color: #409eff; font-size: 0.3rem">{{ order_title }}</span>
            </template>
            <order-com :dataTypeOrder="dataTypeOrder" />
        </el-drawer>
    </div>
</template>

<script>
import { fscDate } from '../../../static/mixins/fastChooseDate'
import UserCom from './Components/UserCompoent'
import OrderCom from './Components/OrderCompoent'
export default {
    name: 'Index',
    mixins: [fscDate],
    components: { UserCom, OrderCom },
    data() {
        return {
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501"
                    : "https://qyh-next-server.zhang66.cn",
            miniProTab: 'reg_now_wc',
            fromTab: '4',
            fieldTabDate: '1',
            fieldTypeTab: '1',
            needType: null,
            needFrom: null,
            needFieldType: null,
            needFieldDate: null,
            fieldData: {
                reg: {},
                order: {}
            },
            fieldDataNew: {},
            todayData: {
                reger: null,
                order_unPay: null,
                order: null
            },
            totalData: {
                reger: null,
                order_unPay: null,
                order: null
            },
            yesterdayData: {
                reger: null,
                order_unPay: null,
                order: null
            },
            locationData: {
                reger: null,
                order_unPay: null,
                order: null
            },
            date: '',
            userDrawer: false,
            user_title: null,
            dataType: {},
            orderDrawer: false,
            order_title: null,
            dataTypeOrder: {}
        }
    },
    methods: {
        loadField() {
            this.fieldData = this.$options.data().fieldData
            this.$axios.get(`${this.hyperfHost}/v1/api/promotion/get_field`, {
                params: {
                    type: this.needType ? this.needType : 'reg_now_wc',
                    from: this.needFrom ? this.needFrom : 4,
                    date_type: this.needFieldDate ? this.needFieldDate : '1',
                    field_type: this.needFieldType ? this.needFieldType : '1',
                    date: this.date
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    // this.fieldData = data.data
                    this.fieldDataNew = data.data
                }
            }).catch()
        },
        loadTotal() {
            this.todayData = this.$options.data().totalData
            this.$axios.get(`${this.hyperfHost}/v1/api/promotion/get_total`, {
                params: {
                    type: this.needType ? this.needType : 'reg_now_wc',
                    from: this.needFrom ? this.needFrom : 4,
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.totalData.reger = data.data.reger
                    this.totalData.order_unPay = data.data.order_unPay
                    this.totalData.order = data.data.order
                }
            }).catch()
        },
        handleClick(val) {
            this.needType = val.name
        },
        getData() {
            this.todayData = this.$options.data().todayData
            this.$axios.get('api/api3_ccrmp_get_promotion_statistics', {
                params: {
                    type: this.needType ? this.needType : 'reg_now_wc',
                    from: this.needFrom ? this.needFrom : 4,
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.todayData.reger = data.data.reger
                    this.todayData.order_unPay = data.data.order_unPay
                    this.todayData.order = data.data.order
                }
            }).catch()
        },
        getDataYesterday() {
            this.yesterdayData = this.$options.data().yesterdayData
            this.$axios.get('api/api3_ccrmp_get_promotion_statistics_yesterday', {
                params: {
                    type: this.needType ? this.needType : 'reg_now_wc',
                    from: this.needFrom ? this.needFrom : 4,

                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.yesterdayData.reger = data.data.reger
                    this.yesterdayData.order_unPay = data.data.order_unPay
                    this.yesterdayData.order = data.data.order
                }
            }).catch()
        },
        handleClickfromTab(val) {
            this.needFrom = val.name
        },
        handleClickFieldDateTab(val) {
            this.date = ''
            this.locationData = this.$options.data().locationData
            this.needFieldDate = val.name
        },
        handleClickFieldTypeTab(val) {
            this.needFieldType = val.name
        },
        handleSearch(val) {
            if (val) {
                this.locationDate()
                this.loadField()
            } else {
                this.locationData = this.$options.data().locationData
            }
        },
        locationDate() {
            this.locationData = this.$options.data().locationData
            if (!this.date) return false
            this.$axios.get('api/api3_ccrmp_get_promotion_statistics_location_date', {
                params: {
                    type: this.needType ? this.needType : 'reg_now_wc',
                    from: this.needFrom ? this.needFrom : 4,
                    date: this.date
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.locationData.reger = data.data.reger
                    this.locationData.order_unPay = data.data.order_unPay
                    this.locationData.order = data.data.order
                }
            }).catch()
        },
        handleCloseUserDrawer(done) {
            // this.$confirm('确认关闭？')
            //   .then((_) => {
            this.dataType = {}
            done()
            //   })
            //   .catch((_) => {})
        },
        handleCloseOrderDrawer(done) {
            // this.$confirm('确认关闭？')
            //   .then((_) => {
            this.dataTypeOrder = {}
            done()
            //   })
            //   .catch((_) => {})
        },
        openUserDrawer(title, key) {
            this.user_title = title
            this.dataType = {
                type: this.needType ? this.needType : 'reg_now_wc',
                from: this.needFrom ? this.needFrom : 4,
                date: this.date,
                key
            }
            this.userDrawer = true
        },
        openOrderDrawer(title, key) {
            this.order_title = title
            this.dataTypeOrder = {
                type: this.needType ? this.needType : 'reg_now_wc',
                from: this.needFrom ? this.needFrom : 4,
                date: this.date,
                key
            }
            this.orderDrawer = true
        }
    },
    watch: {
        needType() {
            this.getData()
            this.getDataYesterday()
            this.locationDate()
            this.loadTotal()
            this.loadField()
        },
        needFrom() {
            this.getData()
            this.getDataYesterday()
            this.locationDate()
            this.loadTotal()
        },
        needFieldDate() {
            this.loadField()
        },
        needFieldType() {
            this.loadField()
        }
    },
    mounted() {
        this.getData()
        this.getDataYesterday()
        this.loadTotal()
        this.loadField()
    }
}
</script>

<style scoped>
.index {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper>>>.el-drawer {
    overflow-y: auto;
}

.title {
    color: #409EFF
}

.title_total {
    color: #000000;
}

.title_field {
    color: #67C23A;
}

.title_field_reg {
    color: #E6A23C;
}

.title_field_order {
    color: #F56C6C;
}

.font-s-m {
    font-size: medium;
    font-weight: bold;
}

/* 表格 */
.centered {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}

#field-table td {
    padding: 0.2rem 0.3rem;
}

.centered-count {
    text-align: right!important;
}

/* 表格end */
</style>


// WEBPACK FOOTER //
// src/pages/PromotionStatistics/Index.vue